<template>
  <DialogDrawer
    id="dialog-settings"
    ref="dialog"
    data-testid="settings.settings-dialog"
    class="dialog-settings"
    placement="centre"
    modal
    @close="onClose"
  >
    <slot></slot>
  </DialogDrawer>
</template>
<script lang="ts" setup>
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';
import {SettingsKey} from '@/components/settings/injectionKeys';
const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');
const active = defineModel<SettingsKey>();
const customerStore = useCustomersStore();

watch(active, (value) => {
  if (value) dialog.value?.openModal();
});

const onClose = () => {
  active.value = '';
  if (customerStore.customerRefreshNeeded) {
    location.reload();
  }
};
</script>
<style lang="scss" scoped>
@media (width >= 768px) {
  .dialog-settings {
    /* margin: 5rem 10rem; */
    margin: 5% 10%;
    width: auto !important;
    height: auto !important;
    max-width: initial !important;
    max-height: initial !important;
  }
}

.dialog-settings > :deep(.card-body) {
  padding: 0 !important;

  .settings-list-group {
    /* top | right | bottom | left */
    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  }
}
</style>
